import React from 'react';
import TemplateRoot from 'components/Layout/SiteOneTemplate';
import './404.scss';

const AccessDeniedPage = () => {
  const redirectUrl = window.profile.clientName
    ? `http://${window.location.host}`
    : `http://${window.location.host.split('.')[1]}`;

  return (
    <TemplateRoot>
      <div id='notfound'>
        <div className='notfound'>
          <div className='notfound-404'>
            <h1>403</h1>
          </div>
          <h2>ACCESS DENIED</h2>
          <p>
            You don't have permission to access this page.
            <a href={redirectUrl}> Return to homepage</a>
          </p>
        </div>
      </div>
    </TemplateRoot>
  );
};

export default AccessDeniedPage;



// WEBPACK FOOTER //
// ./src/errorPage/403.js